import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { useScaffold } from "@Light/scaffold";
import React from "react";
import { FAQBody } from "../support/FAQ/FAQ";
import { useSupportBottomSheet } from "@Light/components/page/SupportBottomSheet";

export type FAQProps = {};

export const FAQ: React.FC<FAQProps> = ({}) => {
  const scaffold = useScaffold();
  const Link = scaffold.system.link;
  const openSupport = useSupportBottomSheet();
  return (
    <FAQBody
      contactWrapper={({ children }) => (
        <div
          onClick={() => {
            openSupport();
          }}
        >
          {children}
        </div>
      )}
      footer={
        <ButtonFooter>
          <Link to="/" className="w-full">
            <Button size="lg" className="w-full">
              Close
            </Button>
          </Link>
        </ButtonFooter>
      }
    />
  );
};
